import i18n from "@/plugins/i18n";
import router from "@/router";

export default function ({ globals }) {
	return {
		namespaced: true,
		state: {
			newPassword: null,
		},
		mutations: {
			SET_NEW_PASSWORD(state, value) {
				state.newPassword = value;
			},
		},
		actions: {
			async send({ state, rootState, dispatch }) {
				try {
					const globalConfig = await globals.getAsyncGlobalVariable("environmentConfig");
					const response = await fetch(`${globalConfig.backends.users}/recover-password`, {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({
							userName: rootState.queryParams.username,
							code: rootState.queryParams.code,
							password: state.newPassword,
						}),
					});

					const { result, error = null } = await response.json();

					if (error) throw new Error(error.code);

					if (result.tokens) {
						dispatch("logger/logSuccess", {
							id: Date.now(),
							handled: true,
							source: "backend",
							notification: i18n.t("changePassword.submit.successMessage"),
							target: {
								type: "flashToast",
								timeout: 4000,
							},
						}, { root: true });

						dispatch("token/clearTokens", null, { root: true });
						setTimeout(() => {
							router.push({ name: "Login" }).catch(() => {});
						}, 1000);
					}
					if (result.challengeName && result.session) {
						dispatch("logger/logSuccess", {
							id: Date.now(),
							handled: true,
							source: "backend",
							notification: i18n.t("changePassword.submit.successMessage"),
							target: {
								type: "flashToast",
								timeout: 4000,
							},
						}, { root: true });
						dispatch("token/clearTokens", null, { root: true });
						dispatch("login/setIdentifier", rootState.queryParams.username, { root: true });
						dispatch("login/setMFAChallenge", { challengeName: result.challengeName, session: result.session }, { root: true });
						setTimeout(() => {
							router.push({ name: "Login" }).catch(() => {});
						}, 1000);
					}
				} catch (error) {
					const translationExists = i18n.te(`changePassword.submit.errorMessages.${error.message}`);
					const code = translationExists ? error.message : "networkError";
					dispatch("logger/logError", {
						id: Date.now(),
						handled: true,
						code,
						source: "backend",
						stack: error,
						notification: i18n.t(`changePassword.submit.errorMessages.${code}`),
						target: {
							type: "flashToast",
							timeout: 4000,
						},
					}, { root: true });
					return;
				}
			},
		},
	};
}
